module.exports = __webpack_public_path__ + "img/check-circle-green.37b6903e.svg";